export default __webpack_public_path__ + "static/media/bit_status2.08c8882b.svg";